
import React from 'react';
import Layout from '../components/Layout';
import CategoryCard from '../components/CategoryCard';
import { calculatorCategories } from '../lib/calculatorUtils';
import { Helmet } from 'react-helmet';

const Index = () => {
  return <Layout>
      <Helmet>
        <title>GetCalculator - Free Online Calculators for Finance, Health & More</title>
        <meta name="description" content="Access 55+ free online calculators for finance, health, education and daily life. User-friendly tools with accurate calculations, no login required." />
        <meta name="keywords" content="free calculators, online calculator, financial calculator, health calculator, BMI calculator, loan calculator, mortgage calculator" />
        <link rel="canonical" href="https://getcalculator.net/" />
        <meta property="og:title" content="GetCalculator - Free Online Calculators for Finance, Health & More" />
        <meta property="og:description" content="Access 55+ free online calculators for finance, health, education and daily life. User-friendly tools with accurate calculations, no login required." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://getcalculator.net/" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="GetCalculator - Free Online Calculators for Finance, Health & More" />
        <meta name="twitter:description" content="Access 55+ free online calculators for finance, health, education and daily life. User-friendly tools with accurate calculations, no login required." />
      </Helmet>
      
      {/* SEO H1 — visually subtle but present for search engines */}
      <section className="pt-10 pb-4 bg-background">
        <div className="container mx-auto px-6 md:px-10">
          <h1 className="text-2xl md:text-3xl font-bold text-foreground">
            Free Online Calculators
          </h1>
          <p className="text-muted-foreground mt-1">
            55+ tools for finance, health, education, lifestyle & more — no signup needed.
          </p>
        </div>
      </section>

      <section id="calculators" className="py-8 md:py-12 bg-background scroll-mt-16" aria-label="Calculator categories">
        <div className="container mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {calculatorCategories.map((category, index) => <div key={category.id} className="animate-fade-in" style={{
            animationDelay: `${index * 0.1}s`
          }}>
                <CategoryCard category={category} />
              </div>)}
          </div>
        </div>
      </section>
      
    </Layout>;
};
export default Index;
